import React from "react";
import styles from "./styles/SummarySection.scss";
import { IndexGallery } from "../../../components";
import { displayPrice, parsePriceString } from "../../../services/utils";

function SummarySection({
  adSummary,
  showViewedCount,
  category,
  specialAttributes
}) {
  const truncateTitle = (source, size) => {
    return source ? (source.length > size ? source.slice(0, size - 1) + "…" : source) : "";
  };

  return (
    <div className={styles.leftPanel}>
      <div className={styles.summarySection}>
        <span className={styles.info}>
          <h1 className={styles.title}>
            {truncateTitle(adSummary.title, 100)}
          </h1>
          <span>
            {adSummary.postedTime && (<span>{`${"Objavljen"}: ${adSummary.postedTime}`}</span>)}
            {adSummary.renewalTime && (<span className={styles.renewalTime}>{`${"Obnovljen"}: ${adSummary.renewalTime}`}</span>)}
          </span>
          <span className={styles.code}>
            {`${"Kod"}: ${adSummary.code}`}
          </span>
          {showViewedCount ? (
            <span className={styles.viewedCount}>
              {"Prikazan: {0} puta".replace(
                "{0}",
                adSummary.viewCount
              )}
            </span>
          ) : null}
        </span>
        {!adSummary.price || adSummary.price === 0 ? null : (
          <span className={styles.pricesWrapper}>
            {adSummary.previousPrice && (
              <span className={styles.prevPrice}>
                {parsePriceString(adSummary.previousPrice)}
              </span>
            )}

            <span className={`${styles.price}`} style={{ paddingTop: adSummary.previousPrice ? 0 : 16 }}>
              {displayPrice(
                adSummary.price,
                adSummary.priceTo,
                {
                  rentPriceType: adSummary.rentPriceType,
                  priceType: adSummary.priceType
                })}
            </span>
            {adSummary.priceM2 && (
              <span className={styles.priceM2}>
                {parsePriceString(Math.round(adSummary.priceM2))}/m<sup>2</sup>
              </span>
            )}
          </span>
        )}
      </div>
      <IndexGallery
        images={adSummary.images}
        floorPlans={adSummary.floorPlans}
        videoUrl={adSummary.videoUrl}
        priceReductionPercentage={adSummary.priceReductionPercentage}
        featuredProperty={adSummary.featuredProperty}
        category={category}
        specialAttributes={specialAttributes}
        adSummary={adSummary}
      />
    </div>
  );
}

export default SummarySection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SummarySection.tsx